/**
 * @author Swathi
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import React, { Component } from 'react';
import { Form, message, DatePicker, Select } from 'antd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitJobPlan,
  getJobPlanById
} from '../../../Utils/FormCalls';
import themeSettings from '../../../Utils/themeSettings.json';
// import history from '../../../../../commons/history';
import translation from '../../../Utils/translation';
import { getTranslationCache } from '../../../../../selectors/language';
import { constant } from '../../../Utils/constants';
import { StyledButton } from '../../../CSS/style';

class FailureReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceList: [],
      organisationsList: [],
      sitesList: [],
      recordData: props.formObject && props.formObject.TaskData ? props.formObject.TaskData : [],
      formObject:
        props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {},
      translationCache: props.translationCache || {}
    };
  }
  taskRef = React.createRef();
  schedulingWorkOrderRef = React.createRef();

  componentDidMount = async () => {
    try {
      let deviceList = await getDeviceList();
      this.setState({ deviceList: deviceList.data });
      let organisationsList = await getOrganisationsList();
      this.setState({ organisationsList: organisationsList.data });
      let sitesList = await getSitesList();
      this.setState({ sitesList: sitesList.data });
    } catch (error) {
      message.warn(`${error.message}`);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.formObject &&
      Object.keys(this.props.formObject).length === 0 &&
      Object.keys(this.state.formObject).length === 0
    ) {
      this.onReset();
    }
    if (this.props.formObject && Object.keys(this.props.formObject).length === 0) {
      this.schedulingWorkOrderRef.current.setFieldsValue(this.props.formObject);
      this.taskRef.current.setFieldsValue(this.props.formObject.TaskData);
    }
    if (prevProps.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }

    if (prevProps.formObject !== this.props.formObject) {
      this.setState({
        formObject: this.props.formObject,
        recordData:
          this.props.formObject && this.props.formObject.TaskData
            ? this.props.formObject.TaskData
            : []
      });
    }
  }

  handleChange = (value, key) => {
    let { formObject } = this.state;

    formObject = {
      ...formObject,
      [key]: value
    };
    this.schedulingWorkOrderRef.current.setFieldsValue(formObject);
    this.setState({ [key]: value, formObject });
  };

  onFinish = async (values) => {
    let { formObject } = this.state;
    let payload = {
      ...formObject,
      ...values
    };
    let statusResponse = await submitJobPlan(payload);

    if (statusResponse && statusResponse.message) {
      // history.goBack();
      message.success(statusResponse.message);
      this.onReset();
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };
  onReset = () => {
    this.taskRef.current.resetFields();
    this.schedulingWorkOrderRef.current.resetFields();
  };
  jobPlanOnChange = async (value) => {
    let formObject = await getJobPlanById(value);
    let recordData = formObject.TaskData;
    // this.schedulingWorkOrderRef.current.setFieldsValue(formObject)
    // this.taskRef.current.setFieldsValue(formObject)
    this.setState({ formObject, recordData, selectedJobPaln: value });
  };
  render() {
    let { formObject, translationCache } = this.state;
    return (
      <>
        <Form
          theme={themeSettings}
          onFinish={this.props.onFinish}
          name={'FailureReport'}
          ref={this.schedulingWorkOrderRef}
          className="jobplan"
          initialValues={formObject}
          layout="horizontal"
          labelCol={{ flex: '130px' }}
          labelAlign="right"
          labelWrap
          //wrapperCol={{ flex: 1 }}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              label={translation(translationCache, constant.failureClass)}
              name="FailureClass"
              onChange={(value) => this.handleChange(value, 'FailureClass')}
              rules={[{ required: false, message: 'Please Input FailureClass!' }]}
              style={{ width: '100%', flex: '50%' }}
            >
              <Select style={{ width: '70%' }}></Select>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.date)}
              name="Date"
              onChange={(value) => this.handleChange(value, 'Date')}
              style={{ width: '100%', flex: '50%' }}
              rules={[{ required: false, message: 'Please Input Date!' }]}
            >
              <DatePicker
                placeholder={translation(translationCache, constant.selectDate)}
                style={{ width: '70%' }}
                format="YYYY-MM-DD HH:mm:ss"
              />
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.failureCode)}
              name="FailureCode"
              style={{ width: '100%', flex: '50%' }}
              onChange={(value) => this.handleChange(value, 'FailureCode')}
              rules={[{ required: false, message: 'Please Input FailureCode!' }]}
            >
              <Select style={{ width: '70%' }}></Select>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.problem)}
              name="Problem"
              style={{ width: '100%', flex: '50%' }}
              onChange={(value) => this.handleChange(value, 'Problem')}
              rules={[{ required: false, message: 'Please Input Problem!' }]}
            >
              <Select style={{ width: '70%' }}></Select>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.cause)}
              name="Cause"
              style={{ width: '100%', flex: '50%' }}
              onChange={(value) => this.handleChange(value, 'Cause')}
              rules={[{ required: false, message: 'Please Input Cause!' }]}
            >
              <Select style={{ width: '70%' }}></Select>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.remedy)}
              name="Remedy"
              style={{ width: '100%', flex: '50%' }}
              onChange={(value) => this.handleChange(value, 'Remedy')}
              rules={[{ required: false, message: 'Please Input Remedy!' }]}
            >
              <Select style={{ width: '70%' }}></Select>
            </Form.Item>
          </div>

          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <StyledButton theme={themeSettings} htmlType="submit">
                {translation(translationCache, constant.save)}
              </StyledButton>
            </Form.Item>
          </div>
        </Form>
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(FailureReport);
